<template>
  <UIModal :show="show">
    <template #header>
      <UIModalHeader
        id="modal-header"
        type="error"
        :title="t('common.deleteOption')"
        :description="modalDescription"
        @close="cancel"
      >
      </UIModalHeader>
    </template>
    <UIModalContent>
      <UIForm id="modal-form" ref="root" :model="formValue" :rules="rules">
        <UIFormItem :label="t('common.deleteConfirmation')" path="deleteConfirm">
          <UIInput
            id="deleteConfirm"
            v-model="formValue.deleteConfirm"
            class="mb-3"
            :placeholder="t('common.deleteCaps')"
          />
        </UIFormItem>
      </UIForm>
    </UIModalContent>
    <template #footer>
      <UIModalFooter
        id="modal-footer"
        :positive-text="t('common.delete')"
        :negative-text="t('common.cancel')"
        type="error"
        @positive-click="confirm"
        @negative-click="cancel"
      >
      </UIModalFooter>
    </template>
  </UIModal>
</template>

<script setup lang="ts">
import {
  UIForm,
  UIFormItem,
  UIInput,
  UIModal,
  UIModalContent,
  UIModalFooter,
  UIModalHeader,
} from "@gohighlevel/ghl-ui";
import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
const { t } = useI18n();

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  description: {
    type: String,
    default: "",
  },
});

// Use a computed property for the description with fallback
const modalDescription = computed(() => {
  return props.description || t("common.deleteConfirmationModal.defaultDescription");
});

watch(
  () => props.show,
  () => {
    if (props.show) {
      formValue.value.deleteConfirm = "";
    }
  }
);

const emit = defineEmits(["confirm", "cancel"]);

const root = ref();

const rules = computed(() => ({
  deleteConfirm: {
    required: true,
    message: t("common.deleteConfirmationModal.validationMessage"),
    trigger: "blur",
    validator(_, value) {
      if ((value ?? "").trim().toLowerCase() !== "delete") {
        return new Error(t("common.deleteConfirmationModal.validationError"));
      }
    },
  },
}));

const formValue = ref({
  deleteConfirm: "",
});

const confirm = async () => {
  if (!root.value?.getForm) {
    console.error("DeleteConfirmationModal validation failed: form ref missing");
    return;
  }

  try {
    await root.value.getForm().validate();
    emit("confirm");
  } catch (error) {
    console.error("DeleteConfirmationModal validation failed:", error);
  }
};

const cancel = () => {
  emit("cancel");
};
</script>
